import { Route, Routes } from 'react-router-dom';
import { ModifySlidingBannerPage } from './ModifySlidingBannerPage';
import { SlidingBannersPage } from './SlidingBannersPage';

export const SlidingBannerPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifySlidingBannerPage />} />
    <Route path='/:slidingBannerID' element={<ModifySlidingBannerPage />} />
    <Route path='*' element={<SlidingBannersPage />} />
  </Routes>
);
